import { render, staticRenderFns } from "./ContactBtn.vue?vue&type=template&id=0849e970"
import script from "./ContactBtn.vue?vue&type=script&lang=js"
export * from "./ContactBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports